import { Modal } from "react-bootstrap";
import ModifierComboGroupDetailsModifier from "./ModifierComboGroupDetailsModifier.js";
import ErrorAlert from "../../../../common/ui/ErrorAlert.js";

export default function ModifierComboGroupDetailsModalPage(props) {
    // Returns the modal page that contains the modifiers in the selected group within the selected Modifier Combo
    let groupIndex = props.modifierComboDetails.selectedGroupIndex;
    let selectedGroupFormData = props.modifierComboFormData.modComboGroups[groupIndex];
    
    // Error Styling
    let badgeClassStyles = "";
    if (props.errorModifierCombo.GroupDetailsPage.HasError) {
        badgeClassStyles = "text-bg-danger";
    } else {
        badgeClassStyles = "text-bg-light badgeLight";
    }
    let isDisabled = props.errorModifierCombo.GroupDetailsPage.ButtonsDisabled || !props.currentLocation.AllowOnlineOrder || !props.currentLocation.Validation.IsValidTableNumber;

    // Badge Text
    let chooseAmountText = "";
    if (props.modifierComboDetails.selectedGroupDetails.type === "Radio") { // Note - Can only be radio inside Group within Modifier Combo
        chooseAmountText = `Choose 1`;
    }
    
    const modifiers = props.modifierComboDetails.selectedGroupDetails.mods.map((mod) => {
        let currentObj = ""; // Filtering and passing just the modifier Form Data
        let fieldName = "";
        let isChecked = "";
        
        if (props.modifierComboDetails.selectedGroupDetails.type === "Radio") { // Note - Can only be radio inside Group within Modifier Combo
            fieldName = `RadioModComboModCatId${props.modifierComboDetails.modifierComboDetails.modCategoryId}ModGroupIndex${groupIndex}ModId${mod.modId}`;
            currentObj = selectedGroupFormData.ModsInGroup.find((modInGroup) => {
                return modInGroup.FieldName == fieldName
            })
        }
        
        return (
            <ModifierComboGroupDetailsModifier
                key={mod.modId}
                type={props.modifierComboDetails.selectedGroupDetails.type}
                modifierDetails={mod}
                modifierFormData={currentObj}
                selectedGroupFormData={selectedGroupFormData}
                handleModifierChangeModComboGroup={props.handleModifierChangeModComboGroup}
                isDisabled={isDisabled}
            />
        )
    })

    return (
        <>
            <Modal.Body>
                <div className="row">
                    <div className="col-12 text-break">
                        <div className="col-12 d-flex justify-content-between pb-1">
                            <b className="me-2">{props.modifierComboDetails.selectedGroupDetails.modCategoryName}</b>
                            <span className={`badge ${badgeClassStyles}`}>{chooseAmountText}</span>
                        </div>
                        {props.modifierComboDetails.selectedGroupDetails.modCategoryDescription && <span>{props.modifierComboDetails.selectedGroupDetails.modCategoryDescription}</span>}
                    </div>
                    <div className="col-12">
                        <hr className="text-body-tertiary"/>
                    </div>
                    <div>
                        {modifiers}
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                { props.errorModifierCombo.GroupDetailsPage.HasError && <div className="px-1 mx-auto mb-3 col-12"><ErrorAlert message={props.errorModifierCombo.GroupDetailsPage.ErrorMessage} /></div> }
                { props.currentLocation.AllowOnlineOrder && props.currentLocation.Validation.IsValidTableNumber && 
                    <div className="col-12 d-flex justify-content-center mx-auto">
                        <button type="button" className="btn btn-dark rounded-pill px-5" onClick={props.handleModifierComboAddSelectionToGroup} disabled={props.errorModifierCombo.GroupDetailsPage.ButtonsDisabled}>
                            Add selection to combo
                            { props.errorModifierCombo.GroupDetailsPage.ButtonsDisabled && <>&ensp;<span className="spinner-border spinner-border-sm" aria-hidden="true"></span></> }
                        </button>
                    </div>
                }
            </Modal.Footer>
        </>
    )
}